const isValidPostcodeWithMatchedPrefix = (p: string): string => {
    const postcode = p?.trim();
    if (!postcode) return;
    const postcodeRegex = /^([A-Za-z]{1,2}\d[A-Za-z\d]?) ?\d[A-Za-z]{2}$/i;
    const match = postcode.match(postcodeRegex);
    return match ? match[1] : '';
}

export default isValidPostcodeWithMatchedPrefix;